import $ from 'jquery';
import LocationAutocompleteWidget from '../classes/LocationAutocompleteWidget';

$(() =>
  $('.autocomplete_address_form')
    .toArray()
    .map((f) => new LocationAutocompleteWidget($(f))),
);
